import Swiper, {
  Navigation,
  Pagination,
  Autoplay,
  EffectFade,
  Thumbs,
  SwiperOptions,
} from 'swiper';

// グローバル登録
Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs]);

document.addEventListener('DOMContentLoaded', () => {
  interface SwiperSetting {
    role: string;
    options: SwiperOptions;
    useLoop?: boolean;
    useFade?: boolean;
    useAutoplay?: boolean;
    speed?: number; // ★追加：スライドの切り替え速度 (ms)
    autoplayDelay?: number; // ★追加：自動再生の待機時間 (ms)
    usePagination?: {
      clickable?: boolean;
      type?: 'bullets' | 'fraction' | 'progressbar' | 'custom';
    };
    thumbnailRole?: string;
    breakpoints?: { [width: number]: SwiperOptions };
  }

  const baseOptions: SwiperOptions = {
    modules: [Navigation, Pagination, Autoplay, EffectFade, Thumbs],
  };

  const swiperConfigs: SwiperSetting[] = [
    {
      role: 'top-mv-swiper',
      useLoop: true,
      useAutoplay: true,
      useFade: true,
      speed: 1500, // ★追記：1.5秒かけてスライド
      autoplayDelay: 5000, // ★追記：5秒ごとに次のスライドへ
      options: {
        slidesPerView: 1,
        spaceBetween: 8,
        centeredSlides: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 8,
        },
      },
      usePagination: { clickable: true },
    },
    {
      role: 'spot-mv-thumb',
      options: {
        slidesPerView: 2.8, // スマホでは3枚
        spaceBetween: 8,
        watchSlidesProgress: true,
      },
      // PC用の設定を上書き
      breakpoints: {
        768: {
          slidesPerView: 5, // 768px以上で5枚
          spaceBetween: 10,
        },
      },
    },
    {
      role: 'spot-mv-swiper',
      thumbnailRole: 'spot-mv-thumb',
      useLoop: true,
      useAutoplay: false,
      useFade: false,
      options: {
        slidesPerView: 1.2, // スマホでは左右を少し見せる
        spaceBetween: 10,
        centeredSlides: true,
      },
      // PC用の設定を上書き
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
      },
      usePagination: { clickable: true },
    },
    {
      role: 'layout-swiper',
      useLoop: true,
      useAutoplay: false,
      useFade: false,
      options: {
        slidesPerView: 1, // スマホでは左右を少し見せる
        spaceBetween: 10,
        centeredSlides: true,
      },
      usePagination: { clickable: true },
    },
    {
      role: 'spot-near-swiper',
      useLoop: true,
      useAutoplay: false,
      useFade: false,
      options: {
        slidesPerView: 1.2, // スマホでは左右を少し見せる
        spaceBetween: 10,
        centeredSlides: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
      },
      usePagination: { clickable: true },
    },
    {
      role: 'accommodations-near-swiper',
      useLoop: true,
      useAutoplay: false,
      useFade: false,
      options: {
        slidesPerView: 1.2, // スマホでは左右を少し見せる
        spaceBetween: 10,
        centeredSlides: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
      },
      usePagination: { clickable: true },
    },
    {
      role: 'top-travel-guide-swiper',
      useLoop: true,
      useAutoplay: false,
      useFade: false,
      options: {
        slidesPerView: 1, // スマホでは左右を少し見せる
        spaceBetween: 10,
        centeredSlides: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 1.8, // スマホでは左右を少し見せる
          spaceBetween: 10,
          centeredSlides: true,
        },
      },
      usePagination: { clickable: true },
    },
    {
      role: 'top-7reason-swiper',
      useLoop: true,
      useAutoplay: true,
      useFade: true,
      speed: 2000, // ★追記：1.5秒かけてスライド
      autoplayDelay: 4000, // ★追記：5秒ごとに次のスライドへ
      options: {
        slidesPerView: 1, // スマホでは左右を少し見せる
        spaceBetween: 10,
        centeredSlides: true,
      },
      usePagination: { clickable: true },
    },
    {
      role: 'top-for-you-swiper',
      useLoop: true,
      useAutoplay: false,
      useFade: false,
      options: {
        slidesPerView: 1, // スマホでは左右を少し見せる
        spaceBetween: 16,
        centeredSlides: false,
      },
      breakpoints: {
        768: {
          slidesPerView: 1.5,
          spaceBetween: 16,
        },
      },
      usePagination: { clickable: true },
    },
    {
      role: 'reasons-mv-swiper',
      useLoop: true,
      useAutoplay: true,
      speed: 2000, // ★追記：1.5秒かけてスライド
      autoplayDelay: 4000, // ★追記：5秒ごとに次のスライドへ
      useFade: true,
      options: {
        slidesPerView: 1, // スマホでは左右を少し見せる
        spaceBetween: 16,
        centeredSlides: true,
      },
      usePagination: { clickable: true },
    },
    {
      role: 'reasons-content-swiper',
      useLoop: true,
      useAutoplay: false,
      useFade: false,
      options: {
        slidesPerView: 1, // スマホでは左右を少し見せる
        spaceBetween: 16,
        centeredSlides: true,
      },
      usePagination: { clickable: true },
    },
  ];

  const initializedSwipers: { [key: string]: Swiper } = {};

  swiperConfigs.forEach((config) => {
    const {
      role,
      options,
      useFade,
      useAutoplay,
      speed,
      autoplayDelay,
      usePagination,
      useLoop,
      thumbnailRole,
      breakpoints,
    } = config;

    // --- 修正ポイント：querySelector ではなく querySelectorAll を使用 ---
    // 指定した role、または「role-数字」に一致する要素をすべて取得
    const elements = document.querySelectorAll(`[data-role^="${role}"]`);

    elements.forEach((element) => {
      // 厳密な判定： role そのもの、あるいは role-1, role-2... の形式のみを対象にする
      const currentRole = element.getAttribute('data-role');
      if (
        !currentRole ||
        (currentRole !== role && !currentRole.startsWith(`${role}-`))
      )
        return;

      // ナビゲーションやドットの要素を取得
      const paginationEl = document.querySelector(
        `[data-role="${currentRole}-nav-pagination"]`
      ) as HTMLElement | null;
      const nextEl = document.querySelector(
        `[data-role="${currentRole}-nav-next"]`
      ) as HTMLElement | null;
      const prevEl = document.querySelector(
        `[data-role="${currentRole}-nav-prev"]`
      ) as HTMLElement | null;

      // --- 修正箇所 ---
      const swiperArgs: SwiperOptions = {
        ...baseOptions,
        ...options,
        ...(speed ? { speed } : {}),
        breakpoints: breakpoints,
        loop: !!useLoop, // 確実に boolean に変換
        effect: useFade ? 'fade' : 'slide',
        ...(useFade ? { fadeEffect: { crossFade: true } } : {}),

        // 修正：型定義に合わせて as 指定を追加（エラーが出る場合のみ）
        autoplay: (useAutoplay
          ? {
              delay: autoplayDelay ?? 8000,
              disableOnInteraction: false,
            }
          : false) as SwiperOptions['autoplay'],

        // ページネーション部分
        pagination: paginationEl
          ? {
              ...(typeof baseOptions.pagination === 'object'
                ? baseOptions.pagination
                : {}),
              ...(usePagination ?? {}),
              el: paginationEl,
            }
          : false, // ページネーションを使わない場合も false が安全

        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
          disabledClass: 'swiper-button-disabled',
        },
      };

      // サムネイル連携
      if (thumbnailRole && initializedSwipers[thumbnailRole]) {
        swiperArgs.thumbs = {
          swiper: initializedSwipers[thumbnailRole],
        };
      }

      const swiper = new Swiper(element as HTMLElement, swiperArgs);
      // 個別のrole名（reasons-content-swiper-1など）で保存
      initializedSwipers[currentRole] = swiper;

      // 再生・停止ボタンの制御
      const toggleBtn = (element as HTMLElement).querySelector(
        '[data-role="swiper-toggle"]'
      );
      if (toggleBtn) {
        const pauseIcon = toggleBtn.querySelector('.icon-pause');
        const playIcon = toggleBtn.querySelector('.icon-play');
        let isPlaying = true;
        toggleBtn.addEventListener('click', () => {
          if (isPlaying) {
            swiper.autoplay?.stop();
            pauseIcon?.classList.add('hidden');
            playIcon?.classList.remove('hidden');
          } else {
            swiper.autoplay?.start();
            playIcon?.classList.add('hidden');
            pauseIcon?.classList.remove('hidden');
          }
          isPlaying = !isPlaying;
        });
      }
    });
  });
});
